<template>
  <div class="slider">
    <div class="slider_arrows" :class="{ whiteSliderButtons: white_buttons }">
      <div ref="leftRef" class="arrow-button-container left">
        <UiUiButtonIco
          mode="button"
          icon="fill-left"
          type="white"
          size="large"
          size-ico="20"
          fill="#363ef8"
        />
      </div>
      <div ref="rightRef" class="arrow-button-container right">
        <UiUiButtonIco
          mode="button"
          icon="fill-right"
          type="white"
          size="large"
          size-ico="20"
          fill="#363ef8"
        />
      </div>
    </div>
    <swiper
      slides-per-view="auto"
      :class="{ move: isDrag }"
      wrapper-tag="ul"
      :allow-touch-move="true"
      :css-mode="false"
      :free-mode="false"
      :navigation="{
        enabled: true,
        disabledClass: 'disabled',
        nextEl: rightRef,
        prevEl: leftRef,
      }"
      :space-between="spaceBetween"
      :modules="[Navigation, FreeMode]"
      :slides-per-group="perGroup"
      @swiper="onSwiper"
      @touch-end="onTouchEnd"
      @touch-move="onTouchMove"
    >
      <template #wrapper-start>
        <slot />
      </template>
    </swiper>
  </div>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper/vue';
import { Navigation, FreeMode } from 'swiper/modules';

defineProps({
  white_buttons: {
    type: Boolean,
    default: true,
  },
  freeMode: {
    type: Boolean,
    default: false,
  },
  spaceBetween: {
    type: Number,
    default: 8,
  },
  perGroup: {
    type: Number,
    default: 1,
  }
});
const onTouchEnd = (swiper, e) => {
  if (e.pointerType === 'mouse' && isDrag.value) {
    nextTick(() => {
      let pos = 0;
      let w = 0;
      swiper.slides.find((v) => {
        w = v.offsetWidth;
        pos += v.offsetWidth;
        return v.classList.contains('swiper-slide-active');
      });

      if (swiper.swipeDirection === 'prev') {
        pos -= w;
      }

      swiper.wrapperEl.scrollTo({
        behavior: 'smooth',
        left: pos,
      });
      setTimeout(() => {
        isDrag.value = false;
      }, 400);
    });
  }
};

const onTouchMove = (swiper, ev) => {
  if (ev.pointerType === 'mouse') {
    isDrag.value = true;
  }
  swiper.wrapperEl.scrollTo({
    left: swiper.wrapperEl.scrollLeft - ev.movementX,
  });
};

const isDrag = ref<Boolean>(false);

const rightRef = ref<HTMLElement>();
const leftRef = ref<HTMLElement>();

const onSwiper = (swiper) => {
  swiper.params.navigation.nextEl = rightRef.value;
  swiper.params.navigation.prevEl = leftRef.value;

  // Re-init navigation
  swiper.navigation.destroy();
  swiper.navigation.init();
  swiper.navigation.update();
};
</script>
<style lang="scss" src="./MultipleSwiperScss.scss" scoped></style>
